/* ============================================================================
   ASISTENTE POR PASOS — sólo en el teléfono
   ----------------------------------------------------------------------------
   Franklin, mirando su móvil: « en teléfono esta forma es muy difícil […]
   aplasto texto, escribo lo que quiero, y luego que pase al siguiente, donde
   ponga polices, y el siguiente color, el siguiente talla. Siguiente,
   siguiente, siguiente, y que acabe ».

   Tenía razón por una razón física: en una pantalla de 375 px el panel de
   texto mide cuatro pantallas de largo, y el cliente no sabe ni cuánto le
   queda ni si ya ha terminado. En el ordenador ese mismo panel se ve entero y
   no sobra nada — así que esto SÓLO se enciende en pantalla pequeña.

   Cómo funciona, sin tocar el panel que ya existía: los bloques del panel
   llevan `data-paso` y `data-titulo`. Aquí se esconden todos menos el del
   paso en curso, y se añaden arriba el nombre del paso y abajo los dos
   botones. El panel sigue siendo el mismo: los mismos campos, los mismos
   identificadores y el mismo código detrás. Si mañana se añade un control,
   basta con meterlo en el bloque que le toque.

   Y una regla que viene de la queja de al lado —« no puedo ver cómo va
   quedando »—: al cambiar de paso se sube la prenda a la vista. Un paso corto
   deja el panel bajo, y la camiseta se ve.
   ========================================================================== */

const ASISTENTE = (() => {
'use strict';

const MOVIL = () => window.matchMedia('(max-width:900px)').matches;

/* Un asistente por panel. La clave es el id del panel. */
const estado = new Map();

function pasosDe(panel) {
  return [...panel.querySelectorAll('[data-paso]')]
    .filter(p => p.offsetParent !== null || true)     // los ocultos también cuentan
    .sort((a, b) => (+a.dataset.paso) - (+b.dataset.paso));
}

function barra(panel, id) {
  let b = panel.querySelector('.asis__tete');
  if (!b) {
    b = document.createElement('div');
    b.className = 'asis__tete';
    b.innerHTML = '<span class="asis__paso"></span><span class="asis__puntos"></span>';
    const corps = panel.querySelector('.panneau__corps') || panel;
    corps.insertBefore(b, corps.firstChild);
  }
  return b;
}

function pie(panel, id) {
  let p = panel.querySelector('.asis__pie');
  if (!p) {
    p = document.createElement('div');
    p.className = 'asis__pie';
    const atras = document.createElement('button');
    atras.className = 'btn asis__b'; atras.type = 'button';
    atras.textContent = '← Retour';
    const sig = document.createElement('button');
    sig.className = 'btn btn--or asis__b'; sig.type = 'button';
    sig.textContent = 'Suivant →';
    atras.onclick = () => mover(panel, id, -1);
    sig.onclick = () => mover(panel, id, +1);
    p.append(atras, sig);
    (panel.querySelector('.panneau__corps') || panel).appendChild(p);
  }
  return p;
}

function mover(panel, id, d) {
  const e = estado.get(id);
  const pasos = pasosDe(panel);
  if (!pasos.length) return;
  const ultimo = pasos.length - 1;
  /* Pasado el último, el asistente se cierra: « y para que acabe ». */
  if (e.i >= ultimo && d > 0) { cerrar(panel); return; }
  e.i = Math.max(0, Math.min(ultimo, e.i + d));
  pintar(panel, id);
  /* La prenda, a la vista: el objetivo de todo esto es verla mientras se
     edita, no adivinar. */
  const escena = document.querySelector('.scene') || document.querySelector('#plateau');
  if (escena && escena.scrollIntoView) escena.scrollIntoView({ block:'center', behavior:'smooth' });
}

function cerrar(panel) {
  const x = panel.querySelector('[data-fermer-panneau]');
  if (x) x.click(); else panel.hidden = true;
}

function pintar(panel, id) {
  const e = estado.get(id);
  const pasos = pasosDe(panel);
  if (!pasos.length) return;
  const activo = MOVIL();
  panel.classList.toggle('asis--on', activo);
  pasos.forEach((p, i) => { p.hidden = activo ? (i !== e.i) : false; });

  const tete = barra(panel, id), foot = pie(panel, id);
  tete.hidden = !activo; foot.hidden = !activo;
  if (!activo) return;

  const actual = pasos[e.i];
  tete.querySelector('.asis__paso').textContent =
    `${e.i + 1}/${pasos.length} · ${actual.dataset.titulo || ''}`;
  tete.querySelector('.asis__puntos').innerHTML =
    pasos.map((p, i) => `<i class="asis__punto${i === e.i ? ' asis__punto--on' : ''}"></i>`).join('');
  const [atras, sig] = foot.querySelectorAll('.asis__b');
  atras.disabled = e.i === 0;
  sig.textContent = e.i === pasos.length - 1 ? 'Terminer ✓' : 'Suivant →';
}

/**
 * Enciende el asistente en un panel. Idempotente: se puede llamar cada vez
 * que el panel se abre.
 */
function activar(panelSel, opciones) {
  const panel = typeof panelSel === 'string' ? document.querySelector(panelSel) : panelSel;
  if (!panel) return;
  const id = panel.id || panelSel;
  if (!estado.has(id)) estado.set(id, { i: 0 });
  if (opciones && opciones.reiniciar) estado.get(id).i = 0;
  pintar(panel, id);
}

/** Va a un paso concreto (0 = el primero). */
function ir(panelSel, i) {
  const panel = typeof panelSel === 'string' ? document.querySelector(panelSel) : panelSel;
  if (!panel) return;
  const id = panel.id || panelSel;
  if (!estado.has(id)) estado.set(id, { i: 0 });
  estado.get(id).i = Math.max(0, i);
  pintar(panel, id);
}

/* Al girar el teléfono o al pasar a pantalla grande, se repinta: en escritorio
   los pasos vuelven a verse todos seguidos. */
window.addEventListener('resize', () => {
  estado.forEach((e, id) => {
    const panel = document.getElementById(id);
    if (panel && !panel.hidden) pintar(panel, id);
  });
});

return { activar, ir, MOVIL };
})();
